export default "__VITE_ASSET__CXIYjCVg__"